export enum Tariff {
    LITE = 'WEB_LITE',
    PRO = 'WEB_PRO',
    PROPlus = 'WEB_PRO+',
    Business = 'WEB_Business',
    UNLIMIT = 'UNLIMIT',
}
